import React from 'react';
import { Sidebar } from './Sidebar';
import '../styles/layout.css';

interface Props { children: React.ReactNode }

export const Layout: React.FC<Props> = ({ children }) => (
  <div className="app-layout">
    <Sidebar />
    <main className="app-main">
      <div className="app-content">{children}</div>
    </main>
  </div>
);
